import _ from 'lodash';
import { createSelector } from 'reselect';

import { getUuid } from 'store/auth/selectors';
import { selectLoanRoles as selectAllLoanRoles } from 'store/system/selectors';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanRoles = createSelector(selectLoanApplication, ({ loanRoles }) => loanRoles);

const selectSortedLoanRoles = createSelector(selectLoanRoles, loanRoles =>
  _.sortBy(loanRoles, [role => _.toLower(role.loanRole)], ['asc']),
);

const selectLoanRolesExceptDeleted = createSelector(selectSortedLoanRoles, loanRoles =>
  loanRoles?.filter(
    ({ isLoanRoleDeleted, isEligibleUserRolesDeleted }) =>
      !isLoanRoleDeleted && !isEligibleUserRolesDeleted,
  ),
);

export const selectExtendedLoanRolesData = createSelector(
  [selectAllLoanRoles, selectLoanRolesExceptDeleted],
  (allLoanRoles, loanRoles) =>
    loanRoles?.map(role => {
      const newUserId = role.pendingChange?.newUserId;
      const potentialUsers = allLoanRoles[role.loanRoleId]?.potentialUsers;

      return {
        ...role,
        fullName: newUserId
          ? potentialUsers?.find(({ userId }) => userId === newUserId)?.fullName || ''
          : `${role.firstName} ${role.lastName}`,
      };
    }),
);

export const selectCurrentUserLoanRoleIds = createSelector(
  [selectLoanRolesExceptDeleted, getUuid],
  (loanRoles, currentUserId) =>
    (loanRoles ?? [])
      .filter(({ userId }) => userId === currentUserId)
      .map(({ loanRoleId }) => loanRoleId),
);
